import { render, staticRenderFns } from "./performanceExplain.vue?vue&type=template&id=06ac89f8&"
import script from "./performanceExplain.vue?vue&type=script&lang=js&"
export * from "./performanceExplain.vue?vue&type=script&lang=js&"
import style0 from "./performanceExplain.vue?vue&type=style&index=0&id=06ac89f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports